


















import { Component, Vue, Prop } from "../vue-ext";
import { HousingCompany, Account, User } from "../models";
import "../components/LoginTopNav";

@Component
export default class InputEmailView extends Vue {
    private regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
    private user: User | null = null;

    private created() {
        this.user = this.root.getCurrentUser() as User;

        setTimeout(() => { 
            (<HTMLInputElement>this.$refs.email).focus();
        }, 100);
    }

    private async next() {
        if (this.user) {
            if (await this.service.user.Exists(this.user.email)) {
                this.$router.push("/input-pin");
            } else {
                this.$router.push("/input-register");
            }
        }
    }

    private isValidEmail(): boolean {
        return !!this.user && this.regex.test(this.user.email);
    }

    // private async test() {
    //     var t1 = await this.root.service.authentication.test();
    //     var t2 = await this.root.service.authentication.testpost();
    //     console.log(t1);
    //     console.log(t2);
    // }
}
